import { openid } from '@app/base';
import { NotificationBase, WispoClient } from '@webinex/wispo';
import { registerAndConnectWispoFCMDevice, WispoFCMHttpClient } from '@webinex/wispo-fcm';
import axios from 'axios';

export interface Notification extends NotificationBase {
  data: any;
}

export const wispoClient = new WispoClient<Notification>({
  http: {
    axios: openid.intercept(axios.create({ baseURL: '/api/wispo' })),
  },
  signalR: {
    hubUri: import.meta.env.VITE_WISPO_HUB_URL,
    accessTokenFactory: openid.token,
  },
});

const wispoFCMClient = new WispoFCMHttpClient({
  axios: openid.intercept(axios.create()),
});

let unsubscribe: (() => Promise<void>) | null = null;

export const addWispoPushNotifications = async () => {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  const sw = await navigator.serviceWorker.getRegistration();

  if (sw == null) return;

  unsubscribe = await registerAndConnectWispoFCMDevice({
    sw: sw,
    deviceType: 'web',
    wispoClient: wispoFCMClient,
  });
};

export const unsubscribeWispoPushNotifications = async () => {
  await unsubscribe?.();
};
